/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Cue_Stand_StraightInputs */

const en_us2_body_assessment_cue_stand_straight = /** @type {(inputs: Body_Assessment_Cue_Stand_StraightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stand up straight.`)
};

const pt_br2_body_assessment_cue_stand_straight = /** @type {(inputs: Body_Assessment_Cue_Stand_StraightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fique em pé, bem reto.`)
};

const es_419_body_assessment_cue_stand_straight = /** @type {(inputs: Body_Assessment_Cue_Stand_StraightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponte de pie, con el cuerpo recto.`)
};

const pt_pt2_body_assessment_cue_stand_straight = /** @type {(inputs: Body_Assessment_Cue_Stand_StraightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fica de pé, bem direito.`)
};

const fr_fr2_body_assessment_cue_stand_straight = /** @type {(inputs: Body_Assessment_Cue_Stand_StraightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiens-toi bien droit.`)
};

const de_de2_body_assessment_cue_stand_straight = /** @type {(inputs: Body_Assessment_Cue_Stand_StraightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steh gerade.`)
};

const it_it2_body_assessment_cue_stand_straight = /** @type {(inputs: Body_Assessment_Cue_Stand_StraightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stai dritto.`)
};

/**
* | output |
* | --- |
* | "Stand up straight." |
*
* @param {Body_Assessment_Cue_Stand_StraightInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_cue_stand_straight = /** @type {((inputs?: Body_Assessment_Cue_Stand_StraightInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Cue_Stand_StraightInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_cue_stand_straight(inputs)
	if (locale === "es-419") return es_419_body_assessment_cue_stand_straight(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_cue_stand_straight(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_cue_stand_straight(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_cue_stand_straight(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_cue_stand_straight(inputs)
	return en_us2_body_assessment_cue_stand_straight(inputs)
});
export { body_assessment_cue_stand_straight as "body-assessment.cue.stand_straight" }